import { CalendarEvent } from "pages/Dashboard/CalendarDayCard";
import React from "react";
import { v4 as uuidv4 } from "uuid";
import { ScheduleModel } from "../MonthCalendar";
import { CourseSchedule, ScheduleEventColor } from "./CourseSchedule";
import { COURSE_TYPEID_NAMES } from "consts/courseScheduleType";

export type CourseSchedulePreviewType = "Lista" | "Kalendarz";
interface CourseSchedulePreviewProps {
  noDataPlaceholder?: React.ReactNode;
  onEventClick?: (event: CalendarEvent) => void;
  schedules: ScheduleModel[];
}

export const CourseSchedulePreview = ({ noDataPlaceholder, onEventClick, schedules }: CourseSchedulePreviewProps) => {
  const grouped = groupByDateFrom(schedules);
  const days = grouped.map((x) => ({
    date: x.dateFrom,
    dayNumber: x.dateFrom.getDate(),
    dayInWeek: x.dateFrom.getDay(),
  }));

  const events = schedules.map((x, idx) => ({
    eventStart: x.dateFrom,
    eventEnd: x.dateTo,
    eventName: x.topicName || x.topicGroupName || x.examName || "Przerwa",
    eventDescription: x.type ? COURSE_TYPEID_NAMES[x.type as keyof typeof COURSE_TYPEID_NAMES] : undefined,
    key: uuidv4(),
    eventColor: colors[idx % colors.length],
    rootObject: x,
  }));

  return (
    <>
      {days.length < 1 ? (
        noDataPlaceholder
      ) : (
        <CourseSchedule
          days={days}
          // @ts-ignore
          events={events}
          onEventClick={onEventClick}
        />
      )}
    </>
  );
};

const colors: ScheduleEventColor[] = ["indigo", "sky", "yellow", "emerald", "red"];
export function groupByDateFrom(courseSchedules: ScheduleModel[]): {
  dateFrom: Date;
  groupedResults: ScheduleModel[];
}[] {
  const grouped: { [key: string]: ScheduleModel[] } = {};

  courseSchedules.forEach((event) => {
    const ne = new Date(event.dateFrom);
    ne.setHours(12);
    const dateKey = ne.toISOString().split("T")[0];
    if (!grouped[dateKey]) {
      grouped[dateKey] = [];
    }
    grouped[dateKey].push(event);
  });

  return Object.keys(grouped).map((dateKey) => ({
    dateFrom: new Date(dateKey),
    groupedResults: grouped[dateKey],
  }));
}
